export default {
  all: [],
};



// WEBPACK FOOTER //
// ./src/app/store/modules/organizationMemberBooking/state.js